import React from "react";
import { SvgIcon } from "@mui/material";

const GenerateCartIcon = ({ fill }) => {
  return (
    <>
      <SvgIcon>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill={fill}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7 18C5.9 18 5.01 18.9 5.01 20C5.01 21.1 5.9 22 7 22C8.1 22 9 21.1 9 20C9 18.9 8.1 18 7 18ZM17 18C15.9 18 15.01 18.9 15.01 20C15.01 21.1 15.9 22 17 22C18.1 22 19 21.1 19 20C19 18.9 18.1 18 17 18Z"
            fill={fill}
          />
          <path
            d="M18.92 6.01C18.72 5.42 18.16 5 17.5 5H6.21L5.66 2.57C5.53 2.24 5.23 2 4.86 2H2V4H4.22L7.29 16.43C6.52 16.79 6 17.58 6 18.5C6 19.88 7.12 21 8.5 21H19V19H8.5C8.22 19 8 18.78 8 18.5C8 18.22 8.22 18 8.5 18H17.5C18.16 18 18.72 17.58 18.92 16.99L21 10V6.01H18.92ZM17.5 16H8.21L7.05 11H19L17.5 16Z"
            fill={fill}
          />
          <path d="M20 2V4H22V6H20V8H18V6H16V4H18V2H20Z" fill={fill} />
        </svg>
      </SvgIcon>
    </>
  );
};

export default GenerateCartIcon;
